module.exports = __webpack_public_path__ + "img/P32.607d56af.png";